import React, { useEffect } from 'react'
import Footer from '../../components/Footer'
import BangGiaChup from '../../components/BangGiaChup'
import ScrollToTop from "../../components/ScrollToTop";
import BangGiaChupBanner from '../../components/Banner/BangGiaFlycamBanner';
export default function BangGia() {
    useEffect(() => {
        document.title = 'MinMin Wedding - Phóng Sự Cưới | Bảng giá';
    }, []);
    return (
        <>
            <ScrollToTop />
            <BangGiaChupBanner />
            <div>
                <BangGiaChup />
            </div>

        </>
    )
}